<template>
    <div class="switch-container">
      <label class="switch">
        <input type="checkbox" v-model="isChecked" />
        <span class="slider"></span>
      </label>
      <span class="switch-text">{{ label }}: {{ isChecked ? "On" : "Off" }}</span>
    </div>
  </template>
  
  <script setup lang="ts">
  import { ref, defineProps, watch } from 'vue';
  
  // Define props to accept the label and a model for the switch
  const props = defineProps<{
    label: string; // The text for the label
    modelValue: boolean; // The initial state of the switch
  }>();
  
  // Define emits for two-way binding
  const emit = defineEmits<{
    (e: 'update:modelValue', value: boolean): void;
    (e: 'changed', value: boolean): void;
  }>();
  
  // Use a reactive reference for the switch state
  const isChecked = ref(props.modelValue);
  
  const updateChecked = () => {
    emit('update:modelValue', isChecked.value);
    emit('changed', isChecked.value);

  };
  
  // Watch for changes and emit updates to the parent
  watch(isChecked, updateChecked);
  </script>
  
  <style scoped>
  .switch-container {
    display: flex;
    align-items: center;
    gap: 8px; /* Adds space between the switch and the text */
  }
  
  .switch {
    position: relative;
    display: inline-block;
    width: 40px; /* Smaller width */
    height: 24px; /* Smaller height */
  }
  
  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }
  
  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    transition: 0.4s;
    border-radius: 34px;
  }
  
  .slider:before {
    position: absolute;
    content: "";
    height: 16px; /* Smaller size */
    width: 16px; /* Smaller size */
    border-radius: 50%;
    left: 4px;
    bottom: 4px;
    background-color: white;
    transition: 0.4s;
  }
  
  input:checked + .slider {
    background-color: #2196f3;
  }
  
  input:checked + .slider:before {
    transform: translateX(16px); /* Adjust the translation */
  }
  
  .switch-text {
    font-size: 14px; /* You can adjust the font size if needed */
  }
  </style>
  